import { render, staticRenderFns } from "./GradientColorPicker.vue?vue&type=template&id=3804f610&"
import script from "./GradientColorPicker.vue?vue&type=script&lang=js&"
export * from "./GradientColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports